
export const getIsDownloadDataFetched = (state, props) => state.dataDownload.params.datafetched;